export enum AttributeType {
    DATE = 'date',
    TIMESTAMP = 'timestamp',
    STRING = 'string',
    DOUBLE = 'double',
    NUMBER = 'number',
    INTEGER = 'integer',
    BOOLEAN = 'boolean',
    LINESTRING = 'linestring',
    MULTILINESTRING = 'multilinestring',
    POINT = 'point',
    MULTIPOINT = 'multipoint',
    POLYGON = 'polygon',
    MULTIPOLYGON = 'multipolygon',
    GEOMETRY = 'geometry',
}
